import React, { Fragment } from "react";
import { Card, CardBody, CardTitle, CardText, Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import nextSteps from '../utils/constants/nextSteps';
import auth from '../utils/firebase/auth';

function VerifiedContent({ isBetaRoleCardShown = true, gotoRolesPage = () => null }) {
  const clonedNextSteps = [...nextSteps];
  const {
    title: betaTitle = 'Enter the Beta',
    subtitle: betaSubtitle = 'Role signup is now open',
    description: betaDescription = '',
    CallToAction: BetaCallToAction
  } = clonedNextSteps.shift() ?? {};
  const betaDescriptionSummary = betaDescription.split('**')[0];
  const reservedUsername = auth?.currentUser?.displayName ?? '';
  
  return (
    <div className="d-flex flex-column gap-3">
      {isBetaRoleCardShown && (
        <>
            <Card className="border-primary-orange-subtle shadow-xs surface-elevated">
              <CardBody className="panel-card-body py-4">
                <div className="d-flex flex-column align-items-center gap-2">
                  <div className="d-inline-flex align-items-center gap-2 px-3 py-2 rounded-pill bg-darker border border-primary-orange-subtle">
                    <FontAwesomeIcon icon={faCircleCheck} size="xl" className="text-primary-orange-emphasis" />
                    <span className="text-secondary text-uppercase small anton-regular">
                      Reservation complete
                    </span>
                  </div>

                  <div className="mt-1">
                    <div className="text-secondary text-uppercase anton-regular">
                      Welcome to Spitface Battles,
                    </div>
                    <div className="display-5 my-2 text-light fw-normal sigmar-regular lh-1" style={{ letterSpacing: '0.15rem' }}>
                      {reservedUsername || '-'}
                    </div>
                  </div>

                  <p className="mb-0 text-secondary anton-regular opacity-75">
                    Next: Choose a role to unlock early beta access.
                  </p>
                </div>
              </CardBody>
            </Card>

            <Card className="border-0 shadow-xs surface-elevated">
              <CardBody className="panel-card-body">
                  <div className="row g-3 align-items-center">
                    <div className="col-12 col-md-7 text-center text-md-start">
                        <CardTitle tag="h2" className="h4 text-primary-orange-emphasis flavors-regular mb-1">
                        {betaTitle}
                        </CardTitle>
                        <CardText className="mb-2 text-secondary text-uppercase small">
                        {betaSubtitle}
                        </CardText>
                        <CardText className="mb-0 text-secondary lh-base anton-regular">
                        {betaDescriptionSummary.split(' Spitface Battles').map((textValue, index, arr) => (
                          <Fragment key={`description-item-${textValue}`}>
                              <span className="text-light">{textValue}</span>&nbsp;
                              {index < arr.length - 1 && (
                                  <strong className="d-inline-block text-primary-orange-emphasis fw-normal sfb-inline anton-regular">
                                      Spitface Battles
                                  </strong>
                              )}
                          </Fragment>
                      ))}
                        </CardText>
                    </div>

                    <div className="col-12 col-md-5">
                        <div className="text-center">
                            {BetaCallToAction ? (
                            <BetaCallToAction className="btn btn-primary btn-cta shadow-xs px-4" handleOnClick={gotoRolesPage} />
                            ) : (
                            <Button
                              outline
                              color="primary"
                              onClick={gotoRolesPage} className="btn-cta fw-semibold border-2 px-4">
                                View Roles
                            </Button>
                            )}
                        </div>
                    </div>
                  </div>
              </CardBody>
            </Card>
        </>
      )}

      {clonedNextSteps.length > 0 ? (
        <div className="row g-3">
          {clonedNextSteps.map(({ icon, title, description, CallToAction }, index) => (
            <div key={`next-step-${title}-li`} className={`col-6 ${index === 0 ? 'col-lg-7' : 'col-lg-5'}`}>
              <Card className="bg-darker-25 shadow-xs border-0 h-100 surface-elevated">
                <CardBody className="panel-card-body d-flex flex-column gap-2">
                  <div>
                    <div className="d-flex justify-content-center align-items-center gap-2">
                      <div className="bg-darkest border border-primary-orange-subtle rounded-3 p-1">
                        <FontAwesomeIcon icon={icon} size="lg" className="text-secondary" />
                      </div>

                      <CardTitle tag="h4" className="mb-0 fw-normal text-primary-orange anton-regular text-center text-md-start">
                        {title}
                      </CardTitle>
                    </div>

                    <div className="my-1">
                      <CardText className="mb-0 text-secondary lh-base anton-regular text-center text-md-start">
                        {description}
                      </CardText>
                    </div>
                  </div>

                  <div className="mt-auto mx-auto pt-2">
                    <CallToAction
                      className={title === 'Track the Build'
                        ? 'btn btn-sm btn-reddit px-4 shadow-xs'
                        : 'btn btn-sm btn-outline-primary shadow-xs border-2 px-4'}
                    />
                  </div>
                </CardBody>
              </Card>
            </div>
          ))}
        </div>
      ) : (
        <Card className="panel-card bg-darker-25 shadow-xs border-0 surface-elevated">
          <CardBody className="panel-card-body">
            <CardText className="text-center text-secondary mb-0">
              You are all set for now. Check the role page for new opportunities and updates.
            </CardText>
          </CardBody>
        </Card>
      )}
    </div>
  )
}

export default VerifiedContent
